import { Cloud, CloudOff, Eye, LogIn, MountainSnow, Plus, Redo2, Save, Star, Undo2, UserRound, Users } from "lucide-react";
import type { TripSummary, User } from "../types";

interface Props {
  summaries: TripSummary[];
  activeId?: string;
  saveState: "saved" | "dirty" | "saving" | "offline" | "conflict";
  canUndo: boolean;
  canRedo: boolean;
  onOpen: (id: string) => void;
  onOpenLibrary: () => void;
  onNew: () => void;
  onSave: () => void;
  onUndo: () => void;
  onRedo: () => void;
  onPreview: () => void;
  user: User | null;
  onManageAccount?: () => void;
  onLogin?: () => void;
  canEdit: boolean;
  canCreate: boolean;
  onManageMembers?: () => void;
  favorite?: boolean;
  onToggleFavorite?: () => void;
}

const saveCopy = {
  saved: "已同步",
  dirty: "有未保存更改",
  saving: "正在保存",
  offline: "尚未同步",
  conflict: "发现版本冲突"
};

export function Topbar({ summaries, activeId, saveState, canUndo, canRedo, onOpen, onOpenLibrary, onNew, onSave, onUndo, onRedo, onPreview, user, onManageAccount, onLogin, canEdit, canCreate, onManageMembers, favorite, onToggleFavorite }: Props) {
  const online = saveState !== "offline" && saveState !== "conflict";
  return (
    <header className="topbar">
      <button className="brand brand-button" onClick={onOpenLibrary} aria-label="打开路线库">
        <span className="brand-mark"><MountainSnow size={22} strokeWidth={1.8} /></span>
        <span><strong>山河行迹</strong><small>路线工作台</small></span>
      </button>
      <div className="trip-switcher">
        <span className="topbar-label">正在编排</span>
        <select name="active-trip" value={activeId} onChange={(event) => onOpen(event.target.value)} aria-label="切换路线">
          {summaries.map((trip) => <option key={trip.id} value={trip.id}>{trip.name}</option>)}
        </select>
        {canCreate && <button className="icon-button new-trip-button" onClick={onNew} title="新建路线"><Plus size={18} /></button>}
      </div>
      <div className="topbar-actions">
        <span className={`sync-state is-${saveState}`}>{online ? <Cloud size={16} /> : <CloudOff size={16} />}<span>{saveCopy[saveState]}</span></span>
        <div className="history-actions">
          <button className="icon-button" onClick={onUndo} disabled={!canEdit || !canUndo} title="撤销（⌘Z）"><Undo2 size={18} /></button>
          <button className="icon-button" onClick={onRedo} disabled={!canEdit || !canRedo} title="重做（⇧⌘Z）"><Redo2 size={18} /></button>
        </div>
        <button className="secondary-button preview-button" onClick={onPreview}><Eye size={17} />预览</button>
        {onToggleFavorite && <button className={`icon-button favorite-button${favorite ? " is-active" : ""}`} onClick={onToggleFavorite} title={favorite ? "取消收藏" : "收藏路线"}><Star size={18} fill={favorite ? "currentColor" : "none"} /></button>}
        {canEdit && <button className="primary-button" onClick={onSave} disabled={saveState === "saving" || saveState === "saved" || saveState === "conflict"}><Save size={17} />保存路线</button>}
        {onManageMembers && <button className="icon-button" onClick={onManageMembers} title="管理协作成员"><Users size={18} /></button>}
        {user && onManageAccount && <button className="user-button" onClick={onManageAccount} title={`${user.name} · 账号设置`}><span>{user.name.slice(0, 1)}</span><UserRound size={15} /></button>}
        {!user && onLogin && <button className="secondary-button" onClick={onLogin}><LogIn size={16} />登录编辑</button>}
      </div>
    </header>
  );
}
